<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Tambah Saldo</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama Admin</label>
                                        <input type="text" class="form-control" placeholder="Nama Area..." disabled v-model="data.nama">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Saldo</label>
                                        <p class="mb-0" v-show="data.loading"><Loading></Loading></p>
                                        <input v-show="!data.loading" type="text" class="form-control" placeholder="Sisa Saldo..." disabled v-model="get.form.saldoText">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Mikrotik</label>
                                        <p class="mb-0" v-show="data.loading"><Loading></Loading></p>
                                        <input v-show="!data.loading" type="text" class="form-control" placeholder="Nama Mikrotik..." disabled v-model="get.form.mikrotikNama">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating" for="tarif">Tarif</label>
                                        <p class="mb-0" v-show="data.loading"><Loading></Loading></p>
                                        <select class="form-control" id="tarif" v-model="data.tarifPilih" v-show="!data.loading">
                                            <option disabled selected>Pilih Tarif</option>
                                            <option v-for="(u, index) in get.form.tarif" :value="u.profile+'-'+u.nama+'-'+u.harga+'-'+u.keterangan+'-'+u.harga_beli" >{{u.nama + " @ " + myGlobal.ribu(u.harga_beli)}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Jumlah Voucher</label>
                                        <input type="number" class="form-control" placeholder="Jumlah Voucher..." v-model="tambah.form.jumlah">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                            <div class="form-group">
                                <button class="btn btn-primary" @click="tambah.submitToMikrotik()" v-show="data.btn">Simpan</button>
                                <h3 v-show="!data.btn">{{"Progress "+data.progress+"/"+tambah.form.jumlah}}</h3>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
  components: { 
    'Loading': Loading
  }, 
  setup() {
	const data = reactive({
		id: "",
		nama: "",
        btn: true,
        tarifPilih: "Pilih Tarif...",
        loading: true,
        progress: 1
    })

	const tambah = {
      	form: reactive({
		    jumlah: "",
            subadminId: data.id
      	}),
		submitToMikrotik() {
            if(data.tarifPilih == "Pilih Tarif...") {
                return false;
            }

            data.btn = false;

            var tpilih = data.tarifPilih;
            var p = tpilih.split("-");

			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
          		ip: get.form.ip,
          		username: get.form.username,
          		password: get.form.password,
          		via: get.form.via,
          		profil: p[0]
        	};
				
			var apiUrl = inter.voucherTambahToMikrotik();
			myGlobal.callMikrotik(datax,apiUrl).then(x => {
				//console.log(JSON.stringify(x));
				if (x.status == true) {
                    // location.href="#/kang-voucher"
                    this.submit(x.data.username);
				} else {
					//alert(x.pesan);
				}
			})
		},
		submit(username) {
            //u.profile+'-'+u.nama+'-'+u.harga+'-'+u.keterangan+'-'+u.harga_beli
            var tpilih = data.tarifPilih;
            var p = tpilih.split("-");

			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
          		subadminId: data.id, // id kang voucher
          		qty: this.form.jumlah,
          		progress: data.progress,
          		subadmin: data.nama,
          		name: username,
          		password: username,
          		mikrotiknama: get.form.mikrotikNama,
          		paketnama: p[1],
          		pakettarif: p[4],
          		paketketerangan: p[3],
          		pakettarifjual: p[2]
        	};
				
			var apiUrl = inter.voucherTambah();
			myGlobal.call(datax,apiUrl).then(x => {
				//console.log(JSON.stringify(x));
				if (x.status == true) {
                    if (data.progress < this.form.jumlah) {
                        data.progress = data.progress + 1;
                        this.submitToMikrotik();
                    } else {
                        location.href="#/kang-voucher";
                    }
				} else {
					//alert(x.pesan);
				}
			})
		}
    }

    const get = {
      	form: reactive({
		    saldo: 0,
		    saldoText: "0",
		    mikrotikNama: "",
		    mikrotikId: "",
            ip: "",
            username: "",
            password: "",
            via: "",
            tarif: [],
      	}),
        saldo() {
			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
          		id: data.id // id kang voucher
        	};
				
			var apiUrl = inter.kangVoucherSaldo();
			myGlobal.call(datax,apiUrl).then(x => {
				if (x.status == true) {
                    this.form.saldo = x.data.saldo;
                    this.form.saldoText = myGlobal.ribu(x.data.saldo);
				} else {
				    console.log("Gagal mengambil saldo");
				}
			})
        },
        mikrotikDetail() {
			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
          		id: data.id // id kang voucher
        	};
				
			var apiUrl = inter.MikrotikDetailFromAdmin();
			myGlobal.call(datax,apiUrl).then(x => {
                //console.log(JSON.stringify(x));
				if (x.status == true) {
                    this.form.mikrotikNama = x.data.nama;
                    this.form.mikrotikId = x.data.id;
                    this.form.ip = x.data.ip;
                    this.form.username = x.data.username;
                    this.form.password = x.data.password;
                    this.form.via = x.data.via;

                    this.tarifVoucher();
				} else {
				    console.log("Gagal mengambil Mikrotik");
				}
			})
        },
        tarifVoucher() {
			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
          		id: this.form.mikrotikId // id kang voucher
        	};
				
			var apiUrl = inter.tarif();
			myGlobal.call(datax,apiUrl).then(x => {
				if (x.status == true) {
                    this.form.tarif = x.data;

                    data.loading = false;
				} else {
				    console.log("Gagal mengambil Mikrotik");
				}
			})
        }
    }
    return {
      data, 
      myGlobal, 
      tambah,
      get
    }

  },
  mounted () {
    document.title = "Tambah Saldo Admin Voucher";

    this.data.id = this.$route.params.id;
    this.data.nama = sessionStorage.getItem("VoucherNama");

    this.get.saldo();
    this.get.mikrotikDetail();

    //alert(this.data.id);
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kang-voucher/buatkan.vue